module.exports = __webpack_public_path__ + "img/张老师-1.c03981f0.png";